var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg44(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96661)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4466_96661",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.500002H24V24.5H0V0.500002Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4466_96661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.87536 20.9871C8.87536 22.5383 7.61784 23.7959 6.06656 23.7959C4.51533 23.7959 3.25781 22.5383 3.25781 20.9871C3.25781 19.4359 4.51533 18.1783 6.06656 18.1783C7.61784 18.1783 8.87536 19.4359 8.87536 20.9871Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28125 18.4544L19.1691 1.47679L19.48 1.69448C20.5071 2.41368 20.7568 3.8294 20.0376 4.85652L8.86848 20.8076",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.125 20.9871C15.125 22.5383 16.3825 23.7959 17.9338 23.7959C19.485 23.7959 20.7425 22.5383 20.7425 20.9871C20.7425 19.4359 19.485 18.1783 17.9338 18.1783C16.3825 18.1783 15.125 19.4359 15.125 20.9871Z",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.3367L15.1306 20.8076",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10352 5.05957L6.27425 3.5396",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54883 7.12305L7.71956 5.60308",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99219 9.18555L9.16292 7.66558",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 11.249L10.6082 9.72905",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83006 1.4775L4.51914 1.69523C3.49201 2.41444 3.24235 3.83011 3.96156 4.85723L10.3825 14.0273",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg44);
export default __webpack_public_path__ + "static/media/44.6f33c5fa5c002987989cc4c0b5cc2f92.svg";
export { ForwardRef as ReactComponent };